export default __webpack_public_path__ + "static/media/2008.a927b95b.png";